<!--
 Copyright 2022 by DomX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of DomX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-overlay :value="sideviewName" >
    <component
      :is="sideviewName"
      :payload="sideviewPayload"/>
  </v-overlay>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import DevicesSideview from '@/components/sideviews/DevicesSideview.vue'
import DistributorDeviceSideview from '@/components/sideviews/DistributorDeviceSideview.vue'
import ClientsSideview from '@/components/sideviews/ClientsSideview.vue'
import { commonModule } from '@/store/modules/store-accessor'
import InstallationsSideview from '@/components/sideviews/InstallationsSideview.vue'

@Component({
  components: {
    DevicesSideview,
    ClientsSideview,
    DistributorDeviceSideview,
    InstallationsSideview
  }
})
export default class TheSideview extends Vue {
  get sideviewName () {
    return commonModule.sideview.name
  }

  get sideviewPayload () {
    return commonModule.sideview.payload
  }

  closeSideview() {
    commonModule.hideSideview();
  }

};
</script>
